import { Component } from "@angular/core";

@Component({
  selector: "pm-usuarios-list",
  templateUrl: "./usuarios-list.component.html",
  styleUrls: ["./usuarios-list.component.sass"]
})
export class UsuariosListComponent {
  public pageTitle = "Login";
  public showUsuarios: boolean = true;
  public showAddUsuario: boolean = false;
  public showEditUsuario : boolean  = false;
  public editnumber: number = 0;  
}
